<template lang="html">
	<div :class="[isHidden ? 'slidedown' : 'slideup']">
		<div class="footer-container" id="footer-container">
			<div class="footer-mobile center d-sm-none">
				<a href="" v-on:click.prevent="slideToggle">{{ btn }}</a>
			</diV>
			<slot name="content"></slot>
		</div>
		<slot name="social"></slot>
	</diV>
</template>

<script>

export default {

	name: 'FooterComponent',

	props: ['trad'],

	data() {
		return {
			isHidden: false,
			btn: this.trad.more,
		}
	},

	computed: {
	},

	mounted() {
	},

	methods: {

		slideToggle() {
			if(this.isHidden) {
				this.isHidden = false
				this.btn = this.trad.more
			} else {
				this.isHidden = true
				this.btn = this.trad.less
				this.scrollToEnd()
			}
		},

		scrollToEnd() {
			const container = document.getElementById("footer-container")
			const elem = document.getElementById("resto-container")
			let scroller
			if(elem !== null) {
				scroller = elem
			} else {
				scroller = window
			}
			let prev = 0
			let baseHeight = container.scrollHeight

			var refreshIntervalId = window.setInterval(() => {
				scroller.scrollBy(0, 15)
			}, 1)

			setTimeout(function() {
				clearInterval(refreshIntervalId);
			}, 300)
		}

	}
}
</script>

<style>
footer .slidedown .footer-container .footer-mobile a:after {
	display: inline-block;
	width: 0;
	height: 0;
	margin-left: 0.255em;
	vertical-align: 0.255em;
	content: "";
	border-top: 0.3em solid;
	border-right: 0.3em solid transparent;
	border-bottom: 0;
	border-left: 0.3em solid transparent;
}
footer .slideup .footer-container .footer-mobile a:after {
	display: inline-block;
	width: 0;
	height: 0;
	margin-left: 0.255em;
	vertical-align: 0.255em;
	content: "";
	border-top: 0;
	border-right: 0.3em solid transparent;
	border-bottom: 0.3em solid;
	border-left: 0.3em solid transparent;
}

@media (max-width: 991px) {
	footer .slideup .footer-container .footer-content .d-flex, footer .slidedown .footer-container .footer-content .d-flex {
		max-height: inherit;
	}
	.search footer .slideup .footer-container .footer-mobile, .search footer .slidedown .footer-container .footer-mobile {
		display: block !important;
	}
	.search footer .slideup .footer-container .footer-content .d-flex, .search footer .slidedown .footer-container .footer-content .d-flex {
		max-height: 0;
		overflow-y: hidden;
		transition: max-height 0.3s ease-in-out;
	}
	.search footer .slidedown .footer-container .footer-content .d-flex {
		max-height: 1000px;
	}

	.search footer .slidedown .footer-container .footer-content .d-flex.d-none, .search footer .slideup .footer-container .footer-content .d-flex.d-none {
		display: block !important;
	}
}

@media (max-width: 576px) {
	footer .slideup .footer-container .footer-content .d-flex, footer .slidedown .footer-container .footer-content .d-flex {
		max-height: 0;
		overflow-y: hidden;
		transition: max-height 0.3s ease-in-out;
	}
	footer .slidedown .footer-container .footer-content .d-flex {
		max-height: 1000px;
	}

	footer .slidedown .footer-container .footer-content .d-flex.d-none, footer .slideup .footer-container .footer-content .d-flex.d-none {
		display: block !important;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/FooterComponent.vue